// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loading-container {\n    display: flex;\n    align-items: center;\n}\n\n.loading-container .loading {\n    flex: 1;\n    text-align: center;\n    font-size: 24px;\n    font-family: sans-serif;\n}\n", ""]);
// Exports
module.exports = exports;
